/* import { getRegistration, RegistrationInfo } from 'actions/challenge'; */
import { fetchRegistration } from 'actions/challenge';
import { handleError } from 'actions/error';
import { fetchChallenge } from 'actions/leaderboard';
import Loading from 'components/Loading';
import SubmitForm from 'components/SubmitForm';
import UserContext from 'contexts/user';
import DefaultLayout from 'layouts/default';
import { useSnackbar } from 'notistack';
import { useContext, useEffect, useState } from 'react';
import { useParams, Redirect } from 'react-router';
import { LeaderboardMeta } from 'types/leaderboard';
import { Registration } from 'types/user';
import './index.css';
const SubmissionPage = () => {
  const params = useParams<{ id: string }>();
  const { enqueueSnackbar } = useSnackbar();
  const { user, getRegistration } = useContext(UserContext);
  const [registration, setRegistration] = useState<Registration>();
  const [leaderboard, setLeaderboard] = useState<LeaderboardMeta>();
  useEffect(() => {
    fetchRegistration(params.id)
      .then((registration) => {
        setRegistration(registration);
      })
      .catch((err) => handleError(enqueueSnackbar, err));
    fetchChallenge(params.id)
      .then((leaderboard) => {
        setLeaderboard(leaderboard);
      })
      .catch((err) => handleError(enqueueSnackbar, err));
  }, [params.id]);
  /* const [registerInfo, setRegisterInfo] = useState<RegistrationInfo[]>([]);
   * useEffect(() => {
   *   if (user) {
   *     getRegistration(params.id)
   *       .then((v) => {
   *         setRegisterInfo(v);
   *       })
   *       .catch(() => {
   *         setRegisterInfo([]);
   *       });
   *   }
   * }, [user]); */
  if (!registration || !leaderboard) {
    return (
      <DefaultLayout>
        <Loading text="Loading Submission Page" />
      </DefaultLayout>
    );
  }
  if (!leaderboard.settings.submissions) {
    enqueueSnackbar('Submissions are currently closed', { variant: 'info' });
    return <Redirect to="../" />;
  }

  return (
    <DefaultLayout>
      <div className="SubmissionPage">
        <SubmitForm
          challengeId={params.id}
          title={registration.teamId ? 'Submit for your team' : 'Submit'}
          submissionRedirect={
            registration.teamId
              ? `/challenges/${params.id}/team`
              : `/profile/submissions/${params.id}/`
          }
        />
      </div>
    </DefaultLayout>
  );
};

export default SubmissionPage;
